export enum DAY_PART_SELECTIONS {
  ALL_KEY = 'all',
  BREAKFAST_KEY = 'Breakfast',
  BURGERS_FOR_BREAKFAST = 'Burgers for Breakfast',
  MAIN_MENU_KEY = 'Main Menu',
}

export enum DAY_PART_IDS {
  ALL_KEY = '3',
  BREAKFAST_KEY = '16',
  BURGERS_FOR_BREAKFAST = '2',
  MAIN_MENU_KEY = '1',
}
